export const commonInputProps = {
    id: String,
    name: String,
    disabled: Boolean,
    placeholder: String,
    maxlength: [String, Number],
    readonly: Boolean,
    autocomplete: String,
}

export const fieldWrapperProps = {
    id: String,
    label: String,
    hint: String,
    error: String | Boolean,
    addOnBefore: String,
    addOnAfter: String,
    tooltip: String,
}
